import { Flex } from '@chakra-ui/react'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function AtualizacoesDosDadosCadastraisMedicos() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods

  const tagForQuestion = Object.fromEntries(questions.flatMap((q) => q.tags.map((tag: string) => [tag, q.slug])))

  const possui_deficiencia = watch ? watch(`form_answers.${tagForQuestion['possui_deficiencia']}`) : undefined

  const estrangeiro = watch ? watch(`form_answers.${tagForQuestion['estrangeiro']}`) : undefined

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        //deficiencia
        if (question.tags.includes('tipo_deficiencia') || question.tags.includes('laudo_deficiencia')) {
          if (possui_deficiencia === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //estrangeiro
        if (question.tags.includes('estrangeiro_visto')) {
          if (estrangeiro === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
